import ScheduleVideoCall from './video_call';

export {ScheduleVideoCall};
